import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { SharedAuthRoutesModule } from '@ftr/ui-auth-routes'
import { makePublicFeatureFlagGuard } from '@ftr/ui-core'

@NgModule({
  imports: [
    SharedAuthRoutesModule,
    RouterModule.forChild([
      {
        path: AppPaths.CourtroomDisplay,
        loadChildren: () =>
          import('./courtroom-display/courtroom-display.module').then(m => m.CourtroomDisplayPageModule),
      },
      {
        path: AppPaths.CourtroomJoin,
        loadChildren: () =>
          import('./courtroom-join/public-courtroom-join.module').then(m => m.PublicCourtroomJoinPageModule),
      },
      {
        path: AppPaths.CourtroomJoinDetail,
        loadChildren: () =>
          import('./courtroom-join-detail/public-courtroom-join-detail.module').then(
            m => m.PublicCourtroomJoinDetailPageModule,
          ),
      },
      {
        path: AppPaths.StandaloneAppDownload,
        loadChildren: () => import('./standalone-apps/standalone-apps.module').then(m => m.StandaloneAppsPageModule),
      },
      {
        path: AppPaths.Request,
        canActivateChild: [makePublicFeatureFlagGuard('public-navigation')],
        loadChildren: () => import('./request/request-pages.module').then(m => m.RequestPagesModule),
      },
    ]),
  ],
  exports: [RouterModule],
})
export class RootModule {}
